<script setup lang="ts">
import { RouterView } from 'vue-router'
import Box from '@uiKit/elements/Box.vue'
import Text from '@uiKit/elements/Text.vue'
import { AuthTopHeader } from '@modules/auth'
import AuthFooter from './AuthFooter.vue'
</script>

<template>
  <Box is="main" class="auth-shell" direction="col">
    <AuthTopHeader />
    <Box class="auth-shell__body">
      <RouterView />
    </Box>
    <Text type="caption" color="muted" align="center" class="auth-shell__assurance">
      Trusted by investors across the UAE · Bank-grade security
    </Text>
    <AuthFooter />
  </Box>
</template>

<style scoped>
.auth-shell {
  min-height: 100dvh;
  background:
    radial-gradient(circle at 0% 0%, rgba(103, 85, 251, 0.06), transparent 35%),
    radial-gradient(circle at 100% 100%, rgba(103, 85, 251, 0.04), transparent 45%),
    var(--p-surface-50);
}

.auth-shell__body {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2.5rem 1.5rem;
  overflow: hidden;
}

.auth-shell__assurance {
  padding: 0 1.5rem 1rem;
  position: relative;
  z-index: 1;
}

@media (max-width: 992px) {
  .auth-shell__body {
    padding: 1.5rem 1rem;
  }

  .auth-shell__assurance {
    padding: 0 1rem 1rem;
  }
}
</style>
